<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import { RouterLink } from 'vue-router'
import { DevBar } from '@/components/app'
import { HeaderLogo, HorizontalNavBarItems, NavigationDrawerItems, UserProfile, ThemeSwitcher, Notifications } from '@/components/app/nav'
import { useTopbarNavItems } from '@/composable/useTopbarNavItems'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useQueryClient } from '@tanstack/vue-query'

const { lgAndUp, mdAndDown } = useDisplay()
const appStore = useAppStore()
const authStore = useAuthStore()
const { organisationNavItems, interviewerNavItems } = useTopbarNavItems()

const drawer = ref(false)

const queryClient = useQueryClient()

if (authStore.shouldClearQueryCache) {
  queryClient.clear()
  authStore.shouldClearQueryCache = false
}
</script>

<template>
  <div>
    <VNavigationDrawer
      v-if="mdAndDown"
      v-model="drawer"
      width="400"
      :nav-items="authStore.selected_interviewing ? interviewerNavItems : organisationNavItems"
    >
      <NavigationDrawerItems :nav-items="authStore.selected_interviewing ? interviewerNavItems : organisationNavItems" />
    </VNavigationDrawer>

    <VAppBar class="layout-horizontal-nav px-6">
      <RouterLink
        to="/"
        class="align-center d-flex text-decoration-none nav-item-title mr-4"
      >
        <HeaderLogo class="layout-horizontal-nav__logo mr-2" /> <span class="nav-item-title">MyHQ</span>
      </RouterLink>
      <VAppBarNavIcon
        v-if="mdAndDown"
        variant="text"
        @click.stop="drawer = !drawer"
      />

      <HorizontalNavBarItems
        v-if="lgAndUp"
        :nav-items="authStore.selected_interviewing ? interviewerNavItems : organisationNavItems"
      />

      <VSpacer />
      <VBtn
        icon
        variant="text"
        color="default"
        size="small"
        class="mr-1 help-button"
        @click="appStore.showQuickHelpDrawer = !appStore.showQuickHelpDrawer"
      >
        <VIcon
          icon="mdi-help-circle"
          size="24"
        />
      </VBtn>
      <!-- <I18nSwitcher /> -->
      <ThemeSwitcher />
      <Notifications />
      <UserProfile v-if="authStore.authenticated" />
    </VAppBar>

    <!-- 👉 Pages -->
    <VMain class="layout-page-content">
      <RouterView v-slot="{ Component, route }">
        <Transition
          name="fade-transition"
          mode="out-in"
        >
          <Component
            :is="Component"
            :key="route"
          />
        </Transition>
      </RouterView>
    </VMain>
    <DevBar v-if="appStore.config.DEV_BAR" />
  </div>
</template>

<style lang="scss">
@use "@sass/horizontal_navbar";

.help-button {
  width: 2rem !important;
  height: 2rem !important;
}
</style>
